export default function ImportDetailTabs({
  tabs = [],
  activeTab,
  onChange,
  className = "",
  testIdPrefix = "",
}) {
  if (!tabs.length) return null;

  return (
    <div className={className} data-testid={`${testIdPrefix}import-tabs`}>
      <ul className="nav nav-tabs">
        {tabs.map(tab => (
          <li key={tab.key} className="nav-item">
            <button
              type="button"
              className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
              data-testid={`${testIdPrefix}import-tab-${tab.key}`}
              onClick={() => onChange(tab.key)}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
